const initialState = () => ({
  isOpened: false,
  payload: null,
  itemType: null
});

const ACTION_KEY = 'PAD_EDITOR_REMOVAL_CONFIRMATION_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      return {
        ...state,
        isOpened: true,
        payload: action.payload,
        itemType: action.itemType,
        actionType: action.actionType
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
